import ProductDescription from './ProductDescription'

const BSCornMasaFlourProduct = {
  ...ProductDescription,
  category: '16',
  subCategory: '016BS',
  IsBroadband: true,
  Size: '',
  Organic: false,
}

export default BSCornMasaFlourProduct
